import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGet, adminPut, adminPost } from "@/lib/adminApi";

const STATUSES = ["nouveau", "lue", "à traiter", "en cours", "en attente utilisateur", "traitée", "archivée"];

export default function Echanges() {
  const [requests, setRequests] = useState([]);
  const [replyTo, setReplyTo] = useState(null);
  const [reply, setReply] = useState("");

  const load = () => adminGet("/requests").then((d) => setRequests(d.requests)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (r, status) => {
    await adminPut(`/requests/${r.id}`, { status }).catch(() => {});
    load();
  };

  const sendReply = async () => {
    if (!reply.trim()) return;
    try {
      await adminPost(`/requests/${replyTo}/reply`, { message: reply });
      toast("Réponse envoyée.");
      setReply("");
      setReplyTo(null);
      load();
    } catch {
      toast("Une erreur est survenue.");
    }
  };

  return (
    <div data-testid="admin-echanges-module">
      <h2 className="rav-admin-h2">Échanges</h2>
      {requests.length === 0 && <p className="rav-page-sub">Aucune demande pour le moment.</p>}
      <div className="rav-admin-list">
        {requests.map((r, i) => (
          <div key={r.id} className="rav-admin-row" data-testid={`request-row-${i}`}>
            <span className="rav-admin-row-label">{r.kind} · {r.email || "utilisatrice inscrite"}</span>
            <span className="rav-admin-row-sub">{r.message}</span>
            {(r.replies || []).map((rep, j) => (
              <span key={j} className="rav-admin-row-sub rav-admin-reply">
                Vous : {rep.message}
              </span>
            ))}
            <span className="rav-admin-row-actions">
              <select className="rav-input rav-admin-select" data-testid={`request-status-${i}`} value={r.status} onChange={(e) => setStatus(r, e.target.value)}>
                {STATUSES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
              <button type="button" className="rav-text-link" data-testid={`request-reply-${i}`} onClick={() => setReplyTo(replyTo === r.id ? null : r.id)}>
                Répondre
              </button>
            </span>
            {replyTo === r.id && (
              <span className="rav-admin-reply-box">
                <textarea className="rav-textarea" data-testid={`reply-text-${i}`} rows={3} placeholder="Votre réponse, en douceur…" value={reply} onChange={(e) => setReply(e.target.value)} />
                <button type="button" className="rav-secondary-button rav-session-btn" data-testid={`reply-send-${i}`} onClick={sendReply}>
                  Envoyer la réponse
                </button>
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
